import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { AlertService } from '../../../services/alert.service';
import { NewsletterService } from '../../../services/newsletter.service';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-newsletter',
  templateUrl: './newsletter.component.html',
  styleUrl: './newsletter.component.scss',
  standalone: false,
})
export class NewsletterComponent implements OnInit {
  public newsletterForm: FormGroup;
  public isLoading = false;
  public isSubscribed = false;

  constructor(
    private formBuilder: FormBuilder,
    private newsletterService: NewsletterService,
    private alertService: AlertService,
    private userService: UserService
  ) {
    this.createForm();
  }

  ngOnInit(): void {
    const user = this.userService.currentUser$.value;
    if (user) {
      this.isSubscribed = Boolean(user.newsletterSubscribed);
      this.newsletterForm.patchValue({
        firstname: user.firstname,
        lastname: user.lastname,
        email: user.email,
      });
    } else {
      this.newsletterForm.get('firstname')?.enable();
      this.newsletterForm.get('lastname')?.enable();
      this.newsletterForm.get('email')?.enable();
    }
  }

  public subscribeToNewsletter(): void {
    if (this.isSubscribed) {
      console.log('User already subscribed');
      return;
    }

    if (!this.newsletterForm.valid) {
      this.newsletterForm.markAllAsTouched();
      console.log('Form not valid');
      return;
    }

    const user = this.userService.currentUser$.value;
    this.isLoading = true;

    const request$ = user
      ? this.newsletterService.subscribeLoggedIn()
      : this.newsletterService.subscribe({
          email: this.newsletterForm.get('email')?.value,
          firstName: this.newsletterForm.get('firstname')?.value,
          lastName: this.newsletterForm.get('lastname')?.value,
        });

    request$.subscribe({
      next: () => {
        this.isSubscribed = true;
        this.newsletterForm.disable();
        if (user) {
          this.userService.currentUser$.next({
            ...user,
            newsletterSubscribed: true,
          });
          this.userService.setUser({
            ...user,
            newsletterSubscribed: true,
          });
        }
        this.alertService.showSuccessAlert(
          'Du hast dich erfolgreich für den Newsletter angemeldet.'
        );
        this.isLoading = false;
      },
      error: () => {
        this.alertService.showErrorAlert(
          'Die Newsletter-Anmeldung konnte leider nicht abgeschlossen werden. Bitte versuche es später erneut.'
        );
        this.isLoading = false;
      },
    });
  }

  private createForm(): void {
    this.newsletterForm = this.formBuilder.group({
      firstname: new FormControl(
        { value: '', disabled: false },
        Validators.required
      ),
      lastname: new FormControl(
        { value: '', disabled: false },
        Validators.required
      ),
      email: new FormControl({ value: '', disabled: false }, [
        Validators.required,
        Validators.email,
      ]),
    });
  }
}
